'use client'
import {
  IMAGE_QUERY
} from "./chunk-AFUSNP5S.mjs";
import {
  getContentfulSafeLocale
} from "./chunk-2QEV6CST.mjs";
import {
  gqlClient
} from "./chunk-DZ54PK2S.mjs";
import {
  __async,
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/api/categories/listing.ts
import { useQuery } from "@tanstack/react-query";
import { gql } from "graphql-request";
import { Exception } from "@wbk/logger";
var getCategories = (props) => __async(void 0, null, function* () {
  try {
    const res = yield gqlClient.request(
      gql`
        query getCategories($lang: String, $limit: Int, $skip: Int, $where: CategoryFilter) {
          categoryCollection(locale: $lang, limit: $limit, skip: $skip, where: $where) {
            items {
              id
              title
              slug
              icon {${IMAGE_QUERY}}
              background {${IMAGE_QUERY}}
              childrenCollection {
                items {
                  id
                  title
                  slug
                  icon {${IMAGE_QUERY}}
                  background {${IMAGE_QUERY}}
                }
              }
            }
          }
        }
      `,
      __spreadProps(__spreadValues({ order: "order_ASC", limit: 25 }, props), { lang: getContentfulSafeLocale(props.lang) })
    );
    return res.categoryCollection.items;
  } catch (error) {
    throw new Exception({ error, name: "getCategories" });
  }
});
var useGetCategories = (props, options) => {
  return useQuery(__spreadValues({
    queryKey: ["getCategories", props],
    queryFn: () => getCategories(props)
  }, options));
};

export {
  useGetCategories
};
//# sourceMappingURL=chunk-UXUS7P6D.mjs.map